// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.00391 7.99806H6V10.002H8.00391V7.99806Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14 10V0.719238L2 3.71924V22L16 22V15H18V22H22V10H14ZM12 3.28079V20H4V5.28079L12 3.28079Z"}}]};

const City10FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-10-filled',
    ref,
    icon: element,
  },
));

City10FilledIcon.displayName = 'City10FilledIcon';

export default City10FilledIcon;
